import {useState , useEffect } from "react";
import healthEmSpin from "@assets/HealthEMLoopAnim.gif";
import "./healthemSpinner.scss";
import ProgressBar from "../../pages/uploadFiles/progressBar";
import { Spin } from "antd";
import CustomTooltip from "@pages/tool-tip";

export function Spinner(props: any){
  const { children, loading = false, tooltip , size = 'default'} = props;
  return (
    <Spin size={size} spinning={loading} indicator={<HealthemSpinner {...props} />}>
      {tooltip ?  <CustomTooltip toolTipvalue={tooltip}>{children}</CustomTooltip> : children}
    </Spin>
  );
};

const HealthemSpinner = ({ size = 30, classname = "", progressBarNeeded = false, progressData = [{progress : 0 , message :''}], strokeColor = "#EF6D2A" , timeLimit = 1000}) => {

  const [progressPer , setProgressPer] = useState<number>(1);
  const [index , setIndex] = useState<number>(0);

  useEffect(() => {
    if(progressBarNeeded && (progressPer < 90)){
      if(progressData[index].progress === progressPer){
        setIndex(index => index + 1);
      }
      const interval = setInterval(() => setProgressPer(progressPer => progressPer + 1), timeLimit/100);
      return () => {
        clearInterval(interval);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[progressPer])

  return (
    <div>
      <div><img height={size} width={size} className={"healthem-spinner" + classname} src={healthEmSpin} alt="healthem spinner" /></div>
      {progressBarNeeded ? <div className='spinner_progress_bar' key={index}><ProgressBar percent={progressPer} strokeColor={strokeColor} />
      <div className='spinner_progress_message'>{progressData[index]?.message}</div></div> : null}
    </div>
  );
};

export default HealthemSpinner;
